import React, {useRef, useState, useEffect} from 'react'
import { showToast } from '../../../Component/Toast';
import Button from '../../../Component/Button'
import {encryptPassword} from '../../../Utils/Crypto'
import useClientHook from "../../../Hooks/useClientHook";
import useRecentLogin from '../../../Hooks/useRecentLogins';
import Spinner from '../../../Component/Loader'
import RecentLogins from '../../../Component/RecentLogins';

export default function Render() {

	let EMAIL = useRef(null), PASS = useRef();

	const [Loader, setLoader] = useState(false);
	const [LoginMessage, setLoginMessage] = useState();

	let params = new URLSearchParams(window.location.search)
	let {client_id, logo} = useClientHook('SCANNER')
	let LOGINS = useRecentLogin();
	let Recent_Logins = LOGINS.get();

	useEffect(() => {
		if (params.get('success') === 'false') {
			setLoginMessage(new URLSearchParams(window.location.search).get('message'))
		}
	}, [params]);

	const submit = () => {

		let username = EMAIL.current.value;
		let password = PASS.current.value;

		if(!Recent_Logins.includes(username)){
			LOGINS.set(username)
		}

		if (!username) {
			showToast({
				type: 'error',
				message: 'Enter Email Address'
			})
			return;
		}
		if (!password) {
			showToast({
				type: 'error',
				message: 'Enter Password'
			})
			return;
		}

		const form = document.createElement('form');
		form.method = "post";
		form.action = "https://auth.dice.tech/auth/scanner/auth";

		let params = {
			username: username,
			password: encryptPassword(username, password),
			referrer: window.location.origin,
			...(client_id ? {client_id: client_id} : undefined)
		}

		for (const key in params) {
			if (params.hasOwnProperty(key)) {
				const hiddenField = document.createElement('input');
				hiddenField.type = 'hidden';
				hiddenField.name = key;
				hiddenField.value = params[key];
				form.appendChild(hiddenField);
			}
		}
		document.body.appendChild(form);

		try {
			setLoader(true)
			form.submit();
		} catch (err) {
			setLoader(undefined)
			showToast({
				type: 'error',
				message: err.response ? err.response.data.message : "Something went Wrong !"
			})
		}
	}

	if (Loader || !client_id) {
		return <div className='w-100 vh-100 d-flex align-items-center justify-content-center' style={{background: '#fff'}}><Spinner/></div>
	}

	return (
		<div className="bg-white d-flex align-items-center vh-100" style={{textTransform: 'none'}}>
			<div className='w-100 p-4 m-auto'  style={{maxWidth: 350}}>
				<div>
					<img alt='Logo' className="mb-1" src={logo} style={{maxWidth: 60}} />
					<h1 className='display-5 fw-bold'>Log in</h1>
				</div>
				<p>Hello, enter your Login details to continue</p>
				
				<form onSubmit={(e)=>{e.preventDefault(); submit()}}>
					<div className="mt-4 mb-2 text-start">
						<input ref={EMAIL} type="text" className="form-control mb-2" placeholder="Email Address" />
						<input ref={PASS} type="password" className="form-control mb-2" placeholder="Password" />
					</div>
					{
						LoginMessage&&
						<p className='text-danger text-left' style={{fontSize: '0.8rem', textAlign: 'left'}}>
							<svg className='me-2' xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path></svg>
							{LoginMessage}
						</p>
					}

					<Button type='submit' name='Log In'/>
				</form>
				{
					Recent_Logins.length?
					<RecentLogins logins={Recent_Logins} onClick={(user)=>{EMAIL.current.value=user; PASS.current.value=''; PASS.current.focus()}} onDelete={(e, user)=>{e.stopPropagation();LOGINS.remove(user)}}/>
					:<></>
				}

			</div>
		</div>
	)
}
